import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const fellowshipsApi = {
    getFellowships: (): Observable<Dtos.GetFellowshipsResponse> => {
        //Create the request.
        let request: Dtos.GetFellowships = new Dtos.GetFellowships();

        //Send request.
        const response: Promise<Dtos.GetFellowshipsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getFellowshipById: (id: number): Observable<Dtos.GetFellowshipByIdResponse> => {
        //Create the request.
        let request: Dtos.GetFellowshipById = new Dtos.GetFellowshipById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetFellowshipByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getFellowshipsByPersonnelId: (personnelId: number): Observable<Dtos.GetFellowshipsByPersonnelIdResponse> => {
        //Create the request.
        let request: Dtos.GetFellowshipsByPersonnelId = new Dtos.GetFellowshipsByPersonnelId();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.GetFellowshipsByPersonnelIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setFellowship: (fellowship: Dtos.Fellowship): Observable<Dtos.SetFellowshipResponse> => {

        let request: Dtos.SetFellowship = new Dtos.SetFellowship();

        request.fellowship = fellowship;

        // send request
        const response: Promise<Dtos.SetFellowshipResponse> = client.post(request);

        return Observable.from(response);

    },
    createFellowship: (personnelId: number): Observable<Dtos.CreateFellowshipResponse> => {
        //Create the request.
        let request: Dtos.CreateFellowship = new Dtos.CreateFellowship();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.CreateFellowshipResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateFellowship: (fellowship: Dtos.Fellowship): Observable<Dtos.ValidateFellowshipResponse> => {

        let request: Dtos.ValidateFellowship = new Dtos.ValidateFellowship();

        request.fellowship = fellowship;

        // send request
        const response: Promise<Dtos.ValidateFellowshipResponse> = client.post(request);

        return Observable.from(response);

    }
}